import {Component} from "react";
import Link from "../../Link/Link";

export default class FooterSocialLink extends Component {
  render() {
    const { acessSocialLinks } = this.props;

    return (
      <>
        {acessSocialLinks &&
          acessSocialLinks.map((link, i) => (
            <Link
              noIcon
              inverted
              className="footer__sociallinks"
              link={link.urlSocial}
              target={"_blank"}
              key={i}
              image={link.iconReference}/>
          ))}
      </>
    );
  }
}
